export default __webpack_public_path__ + "static/PJD2-fa4506e9bb0480459f77dfe6ebba0fc2.svg";